// src/app/providers.tsx

"use client";

import { SessionProvider } from "next-auth/react";
import React, { type ReactNode, useEffect } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { NotificationProvider } from "@/components/Notification"; // Import the corrected NotificationProvider
import { initializeLinkedInTag } from "@/utils/linkedInTag";
import { initializeMetaPixel } from "@/utils/metaPixel";

const queryClient = new QueryClient();

export default function Providers({ children }: { children: ReactNode }) {
  useEffect(() => {
    initializeMetaPixel();
    initializeLinkedInTag();
  }, []);

  return (
    <SessionProvider>
      <QueryClientProvider client={queryClient}>
        <NotificationProvider>{children}</NotificationProvider>
      </QueryClientProvider>
    </SessionProvider>
  );
}
